import { Component, HostBinding, OnInit, TemplateRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ThemeSettingsService } from './shared/services/theme-settings.service';
import { OverlayContainer } from '@angular/cdk/overlay';
import { UINavMenu } from './shared/interfaces';
import { AutheticationService } from './shared/services/authetication.service';
import { WsService } from './shared/services/ws.service';
import {
  CommonService,
  ProductsService,
  ServiceTaxiService,
  StateService,
  SettingsService,
  CustomTranslationService
} from './shared/index';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { Client } from './shared/services/client';
import { mergeMap } from 'rxjs/operators';
import { PingService } from '@app/shared/services/ping.service';

const { version } = require('../../package.json');

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  @HostBinding('class') theme;

  loading = true;
  data: any;
  menu: any;
  menus: UINavMenu[];
  title = 'Utax';
  user = null;
  version = version;
  controlMenu: TemplateRef<any>;
  titlePage: TemplateRef<any>;

  constructor(
    protected translate: TranslateService,
    private overlayContainer: OverlayContainer,
    private themeService: ThemeSettingsService,
    private settingsService: SettingsService,
    public auth: AutheticationService,
    private ws: WsService,
    private service: ServiceTaxiService,
    private product: ProductsService,
    private state: StateService,
    private common: CommonService,
    private pingService: PingService,
    private client: Client,
    private customTranslationService: CustomTranslationService
  ) {
    const browserLang = translate.getBrowserLang();
    translate.addLangs(['ru', 'en', 'ua']);
    translate.setDefaultLang('ru');
    translate.use(browserLang.match(/ru|en|ua/) ? browserLang : 'ru');
    this.pingService.startPingging();
  }

  ngOnInit() {
    localStorage.setItem('timezone', '7200');
    this.auth.auth
      .pipe(
        mergeMap(() => {
          return forkJoin([this.common.getMenu(), this.auth.whoAmI(), this.auth.getPermision()]);
        })
      )
      .subscribe(([menu, whoAmI, permissions]) => {
        this.menus = menu.data.filter(item => item.link !== 'call-center');
        this.state.setParameter('whoAmI', whoAmI.data);
        this.state.setParameter('permisions', permissions.data);
        this.state.permissions$.next(permissions.data);
      });

    this.ws.message.subscribe({
      next: data => {
        let res = JSON.parse(data);

        switch (res.header.type.toLowerCase()) {
          case 'acc': {
            if (res.header.action.toLowerCase() == 'rcv') {
              localStorage.setItem('user_id', res.data.user_id);
              this.user = res.data;
            }
            break;
          }
          case 'ctx': {
            if (res.header.action.toLowerCase() == 'rcv') {
              // console.log( res );
              this.state.setParameter('account', res.data);
            }
            break;
          }
        }
      },
      complete: () => {
        console.error('CLOSE CONNECT');
      }
    }); // TODO if

    this.themeService.theme$.subscribe(data => {
      this.theme = data;
      this.overlayContainer.getContainerElement().className = data;
    });

    if (this.auth.isToken()) {
      this.ws.create(this.client.getWs(), true);
      forkJoin(
        this.service.getService(),
        this.product.getProducts(),
        this.customTranslationService.getListOfLanguages(),
        this.customTranslationService.getListOfTranslations()
      ).subscribe(([service, product, langs, translations]) => {
        this.state.setParameter('services', service.data);
        this.state.setParameter('products', product.data);
        this.state.setParameter('authStatus', true);
        this.customTranslationService.langs = langs;
        this.customTranslationService.translations = translations;
        this.auth.auth.next(true);
        this.settingsService.createSubscription();
        this.loading = false;
      });
    } else {
      this.loading = false;
    }
  }

  onRouteChange(e) {
    e.controlMenu ? (this.controlMenu = e.controlMenu) : undefined;
    e.title ? (this.titlePage = e.title) : undefined;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts